import { useQuery } from 'react-query';
import { QueryKey } from 'src/config/queryKey';
import { getStaticPage } from 'src/common/services/staticPage';
import { StaticPageCode } from 'src/common/models/staticPage';

export const getStaticPageQueryKey = (code: StaticPageCode) => [QueryKey.StaticPage, code];

export const useStaticPageQuery = (code: StaticPageCode) =>
  useQuery(getStaticPageQueryKey(code), () => getStaticPage(code), {
    cacheTime: Infinity,
    staleTime: Infinity,
  });
